export default __webpack_public_path__ + "static/media/pause-stream.3466c061.svg";